export type PlaceRankPreference = 'POPULARITY' | 'DISTANCE';

export interface PlaceSearchPayload {
  city: string;
  country_code: string;
  radius: number;
  place_type?: string;
  /** @deprecated Use `ordering` query param instead */
  rank_preference?: PlaceRankPreference;
}

export type PlaceSearchRequest = {
  payload: PlaceSearchPayload;
  page?: number;
  searchFilters?: PlaceFilters;
  sortBy?: import('../pages/private/Discover/types/placesSearch.types').PlacesFormSort;
};

export type PlaceOpeningHoursEntry = Record<string, string> | string;

export interface PlaceItem {
  id?: string;
  name: string;
  photo_url?: string;
  address?: string;
  short_address?: string;
  rating?: number;
  user_ratings_total?: number;
  opening_hours?: PlaceOpeningHoursEntry[];
  phone_number?: string;
  website?: string;
  description?: string;
  pet_friendly?: boolean | null;
  good_for_children?: boolean | null;
  good_for_group?: boolean | null;
  is_open_now?: boolean;
  place_type_label?: string;
  latitude?: number;
  longitude?: number;
}

export interface PlaceSearchResult {
  count: number;
  next: string | null;
  previous: string | null;
  results: PlaceItem[];
}

export interface PlaceFilters {
  ratings: number[];
  petFriendly: boolean;
  goodForChildren: boolean;
  goodForGroup: boolean;
}

export const PLACE_FILTERS_INITIAL_VALUES: PlaceFilters = {
  ratings: [],
  petFriendly: false,
  goodForChildren: false,
  goodForGroup: false,
};

function toFilterBoolean(value: boolean | null | undefined): boolean {
  return value === true;
}

/** `null` / `undefined` count as false (only explicit `true` is true). */
export function isPlaceBooleanTrue(value: boolean | null | undefined): boolean {
  return value === true;
}

export function normalizePlaceFilters(filters: PlaceFilters): PlaceFilters {
  return {
    ...filters,
    ratings: [...filters.ratings],
    petFriendly: toFilterBoolean(filters.petFriendly),
    goodForChildren: toFilterBoolean(filters.goodForChildren),
    goodForGroup: toFilterBoolean(filters.goodForGroup),
  };
}

export const PLACE_RATING_OPTIONS: { value: number; label: string }[] = [
  { value: 5, label: '5 star' },
  { value: 4, label: '4 star' },
  { value: 3, label: '3 star' },
  { value: 2, label: '2 star' },
  { value: 1, label: '1 star' },
];

export interface PlaceTypeOption {
  value: string;
  label: string;
}

export interface PlaceSearchContextForSave {
  locationLabel: string;
  placeType: string;
  placeTypeLabel: string;
  radiusMeters: number;
  rankLabel: string;
}

export interface PlaceToIdeaPayload {
  name: string;
  place_type: string;
  address: string;
  short_address: string;
  latitude: number;
  longitude: number;
  description: string;
  rating: number;
  user_ratings_total: number;
  phone_number: string;
  website: string;
  pet_friendly: boolean;
  good_for_children: boolean;
  good_for_group: boolean;
  is_open_now: boolean;
  photo_url: string;
  distance_meters: number;
  start_date_time?: string;
  end_date_time?: string;
  external_id: string;
  discover_payload: string;
}

export interface PlaceToIdeaResponse {
  code: string;
  message: string;
  idea_list_name: string;
}

export interface PlaceToTripResponse {
  code: string;
  message: string;
  trip_name?: string;
}
